import { InfoOutlined } from '@mui/icons-material'
import { Alert, Button, Dialog, Stack, Typography } from '@mui/material'
import React from 'react'
import { useIntl } from 'react-intl'

type FileRepoInfoDialogProps = {
  open: boolean
  closeDialog: () => void
}

const FileRepoInfoDialog: React.FC<FileRepoInfoDialogProps> = ({ open, closeDialog }) => {
  const { formatMessage } = useIntl()

  return (
    <Dialog open={open} onClose={closeDialog} maxWidth="md" fullWidth>
      <Stack px={3} py={2}>
        <Typography variant="h5">{formatMessage({ id: 'schemas.repositoryFile.infoDialog.title' })}</Typography>

        <Stack px={2} py={4}>
          <Typography>{formatMessage({ id: 'schemas.repositoryFile.infoDialog.description' })}</Typography>
          <Typography mt={2}>{formatMessage({ id: 'schemas.repositoryFile.infoDialog.uploadDescription' })}</Typography>

          <Typography mt={2}>{formatMessage({ id: 'schemas.repositoryFile.infoDialog.benefits' })}</Typography>

          <Typography component="ul" sx={{ pl: 3 }}>
            <li>{formatMessage({ id: 'schemas.repositoryFile.infoDialog.benefit1' })}</li>
            <li>{formatMessage({ id: 'schemas.repositoryFile.infoDialog.benefit2' })}</li>
            <li>{formatMessage({ id: 'schemas.repositoryFile.infoDialog.benefit3' })}</li>
            <li>{formatMessage({ id: 'schemas.repositoryFile.infoDialog.benefit4' })}</li>
            <li>{formatMessage({ id: 'schemas.repositoryFile.infoDialog.benefit5' })}</li>
          </Typography>
        </Stack>
        <Alert variant="filled" severity="info" icon={<InfoOutlined color="primary" />}>
          {formatMessage({ id: 'schemas.repositoryFile.infoDialog.controlNote' })}
        </Alert>
      </Stack>
      <Stack direction="row" justifyContent="flex-end">
        <Button onClick={closeDialog}>{formatMessage({ id: 'general.close' })}</Button>
      </Stack>
    </Dialog>
  )
}

export default FileRepoInfoDialog
